export const ONE_HALF_PI = Math.PI / 2;
export const THREE_HALF_PI = 3 * Math.PI / 2;
export const TWICE_PI = Math.PI * 2;